import { css, styled } from 'styled-components'

import { Typography } from '../../Typography'

import type {
  StyledContainerProps,
  StyledSubtitleProps,
} from './ScreenTitle.Types'

export const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  white-space: pre-line;

  ${({ $align }) => {
    if ($align === 'center') {
      return css`
        align-items: center;
        text-align: center;
      `
    }
    return css`
      align-items: flex-start;
      text-align: left;
    `
  }};
`

export const StyledTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors['N Content/Primary']};
  overflow-wrap: anywhere;

  b,
  strong {
    color: ${({ theme }) => theme.colors['N Content/Highlighted']};
    font-weight: inherit;
  }
`

export const StyledSubtitle = styled(Typography)<StyledSubtitleProps>`
  white-space: break-spaces;
  ${({ $colorVariant, theme }) => {
    switch ($colorVariant) {
      case 'brand':
        return css`
          color: ${theme.colors['N Content/Highlighted']};

          b,
          strong {
            font-weight: 500;
          }
        `
      case 'secondary-highlight-brand':
        return css`
          color: ${theme.colors['N Content/Secondary']};

          b,
          strong {
            color: ${theme.colors['N Content/Highlighted']};
            font-weight: 500;
          }
        `
      case 'secondary-highlight-primary':
      default:
        return css`
          color: ${theme.colors['N Content/Secondary']};

          b,
          strong {
            color: ${theme.colors['N Content/Primary']};
            font-weight: 500;
          }
        `
    }
  }};
`
